import React from 'react'
import {Image} from 'semantic-ui-react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileWord, faFile, faFileExcel, faFilePdf, faFileCsv } from '@fortawesome/free-solid-svg-icons'

class Thumbnail extends React.Component {
  isNumeric (str) {
    if (typeof str !== "string") return false // we only process strings!
    return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
  }
  getElement () {
    let index = this.props.url && this.props.url.lastIndexOf('.')
    if (!index || index < 0) {
      return (
        <Image src={this.props.src} style={{imageOrientation: 'form-image', marginTop: '5px', verticalAlign: 'middle', width: '50px', height: '50px'}} />
      )
    }
    let fileNameIndex = this.props.url.lastIndexOf('/')
    let fileName = this.props.url.substring(fileNameIndex+1)
    let extension = this.props.url.substring(index).toLowerCase()

    if (this.isNumeric(this.props.url.substring(index+1).toLowerCase())) {
      return <Image src={this.props.src} style={{imageOrientation: 'form-image', marginTop: '5px', verticalAlign: 'middle', width: '50px', height: '50px'}} />
    }

    switch (extension) {
      case '.doc':
      case '.docx':
        return <FontAwesomeIcon style={{width: '50px', height: '50px', verticalAlign: 'middle'}} icon={faFileWord} color={'black'} title={fileName} />
      case '.jpg':
      case '.jpeg':
      case '.png':
        return <Image src={this.props.src} style={{imageOrientation: 'form-image', marginTop: '5px', verticalAlign: 'middle', width: '50px', height: '50px'}} />
      case '.xls':
      case '.xlsx':
        return <FontAwesomeIcon style={{width: '50px', height: '50px', verticalAlign: 'middle'}} icon={faFileExcel} color={'black'} title={fileName} />
      case '.pdf':
        return <FontAwesomeIcon style={{width: '50px', height: '50px', verticalAlign: 'middle'}} icon={faFilePdf} color={'black'} title={fileName} />
      case '.csv':
        return <FontAwesomeIcon style={{width: '50px', height: '50px', verticalAlign: 'middle'}} icon={faFileCsv} color={'black'} title={fileName} />
      default:
        return <FontAwesomeIcon style={{width: '50px', height: '50px', verticalAlign: 'middle'}} icon={faFile} color={'black'} title={fileName} />
    }
  }
  render () {
    return (
      <a href={this.props.url ? this.props.url:this.props.src} target='_blank'>
        {this.getElement()}
      </a>
    )
  }
}

export default Thumbnail




// WEBPACK FOOTER //
// ./src/pages/issues/overview/components/thumbnail/index.js